import { ChipProps } from '@mui/material';

import scssVariables from 'styles/sass-variables.module.scss';

export const chipOverrides = {
  root: ({ ownerState: { color, variant } }: { ownerState: ChipProps }) => ({
    ...(variant === 'outlined' && {
      ...(color === 'primary' && {
        backgroundColor: scssVariables.primary_purple_100,
        '&:hover': {
          backgroundColor: scssVariables.primary_purple_100,
        },
      }),
      ...(color === 'default' && {
        color: scssVariables.greys_text,
      }),
    }),
  }),
};
